import type { AppLauncherApp } from '@weretradeit/ui-react';

/**
 * Die Liste, die der Launcher zeigt.
 *
 * Bis ui-react 0.6.4 stand sie IM PAKET (`src/apps-registry.ts`, 16 Eintraege)
 * und der Aufruf uebergab nur `currentApp`. 3.x nimmt die Liste ausdruecklich
 * entgegen — eine hausinterne Anwendungsliste in einem Bauteilpaket war ohnehin
 * am falschen Ort: jede Aenderung an einer URL brauchte eine neue Paketfassung.
 *
 * Woertlich uebernommen aus 0.6.4, damit der Umzug am Launcher nichts
 * verschiebt. NICHT verwechseln mit `public/apps-registry.json`: die Datei
 * bedient das Benutzer-Widget und wird von `intranet.weretrade.com` geholt,
 * nicht von hier.
 */
export const launcherApps: AppLauncherApp[] = [
  { key: 'webos', name: 'WebOS Portal', href: 'https://webos.weretrade.com' },
  { key: 'services', name: 'Service Ant', href: 'https://services.weretrade.com' },
  { key: 'shop', name: 'Shop Beaver', href: 'https://shop.weretrade.com' },
  { key: 'inventar', name: 'Inventar Owl', href: 'https://inventar.weretrade.com' },
  { key: 'accounting', name: 'Account Fox', href: 'https://fox.weretrade.com' },
  { key: 'seller-hub', name: 'Seller Meerkat', href: 'https://hub.weretrade.com' },
  { key: 'assetbee', name: 'AssetBee', href: 'https://assets.weretrade.com' },
  { key: 'neural-whale', name: 'Neural Whale', href: 'https://neural.weretrade.com' },
  { key: 'metric-mole', name: 'Metric Mole', href: 'https://mole.weretrade.com' },
  { key: 'market-shark', name: 'Market Shark', href: 'https://shark.weretrade.com' },
  { key: 'design-butterfly', name: 'Design Butterfly', href: 'https://designbutterfly-pages.pages.dev' },
  { key: 'pipe-squid', name: 'Pipe Squid', href: 'https://pipe.weretrade.com' },
  { key: 'infrastructure-dog', name: 'Infrastructure Dog', href: 'https://infra.weretrade.com' },
  { key: 'testing-octopus', name: 'Testing Octopus', href: 'https://tests.weretrade.com' },
  { key: 'scanopy-monitor', name: 'Scanopy Monitor', href: 'https://scanopy.weretrade.com' },
  { key: 'weretrade-main', name: 'weretradeIT', href: 'https://weretrade.com' },
];
